import * as e from 'react';
import { forwardRef, memo } from 'react';

var n=({title:r,titleId:t,...o},l)=>e.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",fill:"currentColor",ref:l,"aria-labelledby":t,...o},r?e.createElement("title",{id:t},r):null,e.createElement("path",{d:"m6 12.62-.71-.71L9.25 8 5.33 4.09 6 3.38 10.67 8Z"})),f=forwardRef(n),m=memo(f),g=m;

export { g as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-KXTN4YJ3.mjs.map